import { forwardRef } from 'react'
import { tv } from 'tailwind-variants'

import { Button, type ButtonProps } from './button'

const iconButtonStyles = tv({
  variants: {
    size: {
      dense: 'px-0 min-w-7',
      xs: 'px-0 min-w-7',
      sm: 'px-0 min-w-8',
      md: 'px-0 min-w-9',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type IconButtonProps = Omit<ButtonProps, 'loadingText'>

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ size = 'md', className, ...props }, ref) => (
    <Button ref={ref} size={size} className={iconButtonStyles({ size, className })} {...props} />
  ),
)
IconButton.displayName = 'IconButton'
